import { render, staticRenderFns } from "./NestedTextInput.vue?vue&type=template&id=31356bb8&scoped=true&"
import script from "./NestedTextInput.vue?vue&type=script&lang=js&"
export * from "./NestedTextInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31356bb8",
  null
  
)

export default component.exports